function Timer(element, endDate) {
  const theEnd = new Date(endDate);
  const endTime = theEnd.getTime();

  this.start = function() {
    const now = Date.now();
    if (now >= endTime) {
      element.innerHTML = endDate;
    } else {
      setInterval(function() {
        setTimer();
      }, 1000);
    }
  };

  const setTimer = function() {
    const dif = endTime - Date.now();
    const data = convert(dif);
    element.innerHTML = data.day + 'd ' + data.hour + 'h ' + data.minute + 'm ' + data.seconds + 's';
  };

  const convert = function(milliseconds) {
    const seconds = Math.floor(milliseconds / 1000);
    const minute = Math.floor(seconds / 60);
    const hour = Math.floor(minute / 60);
    const day = Math.floor(hour / 24);
    return {
      day: day,
      hour: formatTime(hour % 24),
      minute: formatTime(minute % 60),
      seconds: formatTime(seconds % 60)
    };
  };

  const formatTime = function(time) {
    return time < 10 ? '0' + time : time;
  };
}

const startTimer = function() {
  // Support both the original ID-based timer and class-based timers
  const elm = document.getElementById('js-countdown-timer');
  if (elm != null) {
    const endDate = elm.dataset.end;
    const timer = new Timer(elm, endDate);
    timer.start();
  }

  // Initialize all countdown timers with class 'countdown-timer'
  const timers = document.querySelectorAll('.countdown-timer');
  timers.forEach(function(timerElm) {
    if (timerElm.id !== 'js-countdown-timer') { // Don't double-initialize the main timer
      const endDate = timerElm.dataset.end;
      const timer = new Timer(timerElm, endDate);
      timer.start();
    }
  });
};

if (
  document.readyState === 'complete' ||
  (document.readyState !== 'loading' && !document.documentElement.scroll)
) {
  startTimer();
} else {
  document.addEventListener('DOMContentLoaded', startTimer);
}
